import {
  LOAD_TRACKINGDATA,
  LOAD_VEHICLE_TRACKINGDATA,
  LOAD_VEHICLE_TYPE_TRACKINGDATA
} from "./actions";

const initialState = {
  trackingdatagUrl: "",
  vehicleLists: [],
  vehicleTypeLists: [],
  trackingdataLoading: false
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOAD_TRACKINGDATA.REQUEST:
      const { loading } = action.payload;
      return {
        ...state,
        trackingdataLoading: loading
      };
    case LOAD_TRACKINGDATA.SUCCESS:

      return {
        ...state,
        trackingdataUrl: action.payload.data.data,
        trackingdataLoading: false
      };
    case LOAD_VEHICLE_TRACKINGDATA.REQUEST:
      const { loading_vehicle } = action.payload;
      return {
        ...state,
        trackingdataLoading: loading_vehicle
      };
    case LOAD_VEHICLE_TRACKINGDATA.SUCCESS:
      return {
        ...state,
        vehicleLists: action.payload.data.data,
        trackingdataLoading: false
        //  loading: false
      };
    case LOAD_VEHICLE_TYPE_TRACKINGDATA.SUCCESS:
      // console.log(action.payload.data.data);
      return {
        ...state,
        vehicleTypeLists: action.payload.data.data
      };
    default:
      return state;
  }
};
